export default __webpack_public_path__ + "996082a0e6ed0a6c3d7f1e6fc169a08e.png";